import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import Project from 'models/project/project.model';
import { ProjectService } from 'services/project/project.service';
import TicketCategory from 'models/ticket-category/ticket-category.model';
import { TicketCategoryService } from 'services/ticket-category/ticket-category.service';
import { CreateTicketCategoryComponent } from 'modules/ticket-category/create-ticket-category/create-ticket-category.component';

@Component({
  selector: 'app-list-ticket-category',
  templateUrl: './list-ticket-category.component.html',
  styleUrls: ['./list-ticket-category.component.scss'],
})
export class ListTicketCategoryComponent implements OnInit, OnDestroy {
  @Input() public project: Project;
  public ticketCategories: TicketCategory[] = [];

  private ticketAttributeSubscription: Subscription;

  constructor(
    public projectService: ProjectService,
    public ticketCategoryService: TicketCategoryService,
    public snackBar: MatSnackBar,
    public router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.list();
  }

  list() {
    this.ticketCategoryService.list(this.project).then((ticketCategories) => {
      this.ticketCategories = ticketCategories;
    });
  }

  create() {
    this.router.navigate(['/ticketattribute/create'], { queryParams: { project: this.project.id } });
  }

  async del(item: TicketCategory) {
    if (await this.ticketCategoryService.delete(item)) {
      this.snackBar.open('Törlés sikeres.', '', {
        duration: 2000,
      });
    }
    this.list();
  }

  openModal(item?: TicketCategory) {
    const ref = this.dialog.open(
      CreateTicketCategoryComponent,
      {
        minWidth: '350px',
        data: { item, project: this.project },
        panelClass: 'attribute-panel',
      },
    );
    ref.afterClosed().subscribe(() => {
      this.list();
    })
  }

  ngOnDestroy() {
    if (this.ticketAttributeSubscription) {
      this.ticketAttributeSubscription.unsubscribe();
    }
  }
}
